// External dependencies
import * as imageConversion from 'image-conversion';

// Local dependencies
import { convertImageToBase64, convertImageToBinaryString } from './image-converter-helper';

async function compressedImage(file) {
  const maxImageSize = 3000000;

  let image;

  if (file?.type === 'image/svg+xml' && file.size < maxImageSize) {
    image = await convertImageToBinaryString(file);
  } else {
    const res = await imageConversion.compressAccurately(file, 200);
    image = await convertImageToBase64(res);
  }

  return image;
}

export default compressedImage;
